import { render, staticRenderFns } from "./SelectCfop.vue?vue&type=template&id=4c16a97a&"
import script from "./SelectCfop.vue?vue&type=script&lang=js&"
export * from "./SelectCfop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports